import * as React from 'react';
import { HookPaginationProps } from '../../../../common/hook/usePaginationHook';
import SchemaForm from '../../../../common/SchemaForm';
import { schemaFilterEncounterForm } from './schema';
import { ENCOUNTER_STATUS } from 'modules/common/apiConstants';

interface Props {
  hookPagination: HookPaginationProps;
  pagin?: React.ReactNode;
}

const FilterIndicationBox: React.FunctionComponent<Props> = (props) => {
  const { hookPagination, pagin } = props;
  const { params, setParams, clearParams } = hookPagination;
  return (
    <SchemaForm
      schema={schemaFilterEncounterForm}
      onSubmit={(value) => setParams(value)}
      formData={params}
      clearParams={() =>
        clearParams({
          status: [ENCOUNTER_STATUS.INPROGRESS.value, ENCOUNTER_STATUS.ARRIVED.value, ENCOUNTER_STATUS.FINISHED.value],
        })
      }
      hideSubmitButton
      pagin={pagin}
    />
  );
};

export default FilterIndicationBox;
